import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useCompany } from "@/context/CompanyContext";
import { CompanyPaySection, paySettingsFrom, paySettingsPayload } from "@/components/CompanyPaySection";

export const CompanyDetailsDialog = ({ open, onOpenChange }) => {
  const { company, setCompany } = useCompany();
  const [v, setV] = useState(() => paySettingsFrom(company));
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setV(paySettingsFrom(company)); }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const save = async () => {
    setBusy(true);
    try { setCompany(await api.updateCompany(paySettingsPayload(v))); toast.success("Company settings saved"); onOpenChange(false); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not save"); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" data-testid="company-details-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">Payroll &amp; business details</DialogTitle>
          <DialogDescription>These apply to every depot in {company?.name || "your company"}.</DialogDescription>
        </DialogHeader>
        <CompanyPaySection value={v} onChange={setV} />
        <DialogFooter>
          <Button onClick={save} disabled={busy} className="rounded-full bg-primary hover:bg-primary/90 text-white" data-testid="company-details-save">
            {busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
